import React from "react";
import LoadingComp from "src/components/shared/LoadingComp";

export default function DeliveredReceipt({ html, isLoading }) {
  return <>{isLoading ? <LoadingComp /> : <div dangerouslySetInnerHTML={{ __html: html }} />}</>;
}
